import {
  buildPhysicalOrderWhatsAppMessage,
  buildWhatsAppUrl,
  resolveCompanyWhatsApp,
} from '../../utils/whatsapp';
import './WhatsAppCoordinateButton.css';

const WhatsAppCoordinateButton = ({
  phone,
  firstName,
  orderNumber,
  totalAmount,
  currency,
  lines,
  className = '',
  children,
}) => {
  const resolved = resolveCompanyWhatsApp(phone);
  const href = buildWhatsAppUrl(
    resolved,
    buildPhysicalOrderWhatsAppMessage({
      firstName,
      orderNumber,
      totalAmount,
      currency,
      lines,
    }),
  );
  if (!href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`wa-coordinate-btn ${className}`.trim()}
    >
      <i className="fab fa-whatsapp" aria-hidden="true" />
      {children || 'Coordinar envío por WhatsApp'}
    </a>
  );
};

export default WhatsAppCoordinateButton;
